import React from 'react';

import style from './style.module.less';

/**
 * @typedef {import('../../../../../../../prop-types/intl').MessageDescriptorPropType} MessageDescriptorPropType
 */

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */

export const ItemCell = ({ children }) => {
  return <div className={style['item-cell']}>{children}</div>;
};
